import React from 'react'
import "./footer.css"

function Footer() {
    return (
        <div className="footer">
            <p>© 2020 Airbnb Clone, Inc. All rights reserved</p>
            <p>Design and Developed by - <strong>Saurabh Kumar</strong></p>
        </div>
    )
}

export default Footer;
